import api from "./api";
import System from "@/model/system";
import router from "@/router";

class AwsApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getMqttEndpoint (system: System) {
    const response = await this.getHttp().post<any>('signed-ws', {
      shop_token: system.shop_token,
      session_token: system.session_token,
      request_token: system.request_token,
      customer_token: system.customer_token,
    }).catch((error) => {
      return error;
    });

    if (response.status != 200) {
      console.log("[Error] Call API POST /signed-ws");
      router.replace({ name: "error",  query: { errorMessage: '[ServerRequest] Websocket URL の取得に失敗しました。' } });
      return;
    }

    return response.data.mqtt_endpoint;
  }
}

export default new AwsApi();
